
export class StateHandler {

  private _state: any
  private statename: string

  public events: Phaser.Events.EventEmitter

  constructor( statename:string ){
    this.statename = statename
    this.events = new Phaser.Events.EventEmitter();
    var st = localStorage.getItem(this.statename);
    if (st){
      this._state = JSON.parse(st)
    }else{
      this._state = {}
    }
  }

  get(key:string,defaultResult?:any, type:string = 'string'){
    if (!this._state[key]){
      return defaultResult
    }else{
      return this._state[key];
    }
  }

  set(key:string, value:any){
    //console.log('SETGLOBAL', key,value)
    if (value === 'NULL'){
      delete this._state[key]
    }else{
      this._state[key] = value
    }
    localStorage.setItem( this.statename, JSON.stringify(this._state))
    this.events.emit('change',key)
  }

  reset(){
    localStorage.removeItem(this.statename);
  }

  remove(keyPattern:string){
    var rmNames:string[] = Object.keys( this._state ).filter((k:string)=>k.indexOf(keyPattern)===0)
    rmNames.forEach( (k)=>{delete this._state[k]; console.log(k)} )
    this.set('cleared', new Date().getTime())
    console.log('removeStates:',rmNames)
  }


  initDebug(){

    var r = document.createElement('div')
    r.classList.add('state_debug')
    r.innerHTML = '<button>&laquo;</button><div class="inner"><textarea></textarea><div><button class="save">SAVE</button><button class="dump">DUMP TO SERVER</button></div></div>'
    document.body.appendChild(r)
    
    var btn = document.querySelector('.state_debug>button')
    var txt:any = document.querySelector('.state_debug textarea')
    var save = document.querySelector('.state_debug .inner button.save')
    var dump = document.querySelector('.state_debug .inner button.dump')
    btn?.addEventListener('click',()=>{
      r.classList.toggle('show')
      if (r.classList.contains('show')){
        var st:string = localStorage.getItem(this.statename) as string
        var stObj:any = JSON.parse(st);        
        (txt as any).value = JSON.stringify(stObj,null,2)
      }
      console.log('toggle')
    })
    save?.addEventListener('click',()=>{
      var s = txt?.value;
      localStorage.setItem(this.statename,s)
      r.classList.toggle('show')
    })

    dump?.addEventListener('click',async ()=>{
      var st:string = localStorage.getItem(this.statename) as string;
      var s = (document as any).querySelector('body').getAttribute('server');
      var addr = (s.charAt(0)==='{') ? 'http://localhost:8200/dump' : s+'/dump';

      const response = await fetch(addr,{ 
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: st
      })
      try {
        const result = await response.json();
        alert('done'+result.name)
      }catch(e){
        console.log('no data')
        alert('DONE')
      }
    })

  }

}